export default __webpack_public_path__ + "static/media/removeImg.f1fb02a5.svg";